import { TranslateService } from '@ngx-translate/core';
import { ProfileCollectionService } from './../../profile-collection/services/profile-collection.service';
import { ElementRef, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OutcomeType, UserOutcomeDetail } from '@app/outcomes/outcomes-api';
import { ProfileCollectionModel } from '@app/profile/profile-api';
import { ACHIEVEMENT_TYPES } from '@app/profile/components/profile-overview-v2/profile-overview.service';
import { catchAndSurfaceError } from '@app/shared/utils';
import { NgxHttpClient } from '@app/shared/ngx-http-client';
import { UserOutcomeModalService } from '@app/outcomes/services/user-outcome-modal.service';

@Injectable({
  providedIn: 'root',
})
export class AchievementsService {
  constructor(
    private http: NgxHttpClient,
    private profileCollectionService: ProfileCollectionService,
    private translateService: TranslateService,
    private userOutcomeModalService: UserOutcomeModalService
  ) {}

  /**
   * Get the 'count' number of most recent achievement ProfileCollectionItems. These correspond to ACHIEVEMENT_TYPES,
   * sorted by most recently added.
   *
   * @param userKey - The key for the user
   * @param start - The start index
   * @param count - How many experiences to return
   * @param tagName (Optional) - Get achievements that have been tagged with this tag name
   * @param achievementType (Optional) - Get the achievements only for this type
   */
  public getMostRecentAchievementsModel(
    userKey: number,
    start: number,
    count: number,
    tagName: string = '',
    achievementType: string
  ): Observable<ProfileCollectionModel<UserOutcomeDetail>> {
    const facets = [
      {
        id: 'Type',
        name: 'Type',
        values: achievementType ? [achievementType] : ACHIEVEMENT_TYPES,
      },
    ];
    return this.profileCollectionService.getCollectionModel(
      userKey,
      facets,
      start,
      count,
      tagName,
      ''
    );
  }

  public getAchievementDetails(
    userKey: number,
    userOutcomeId: number
  ): Observable<UserOutcomeDetail> {
    return this.http
      .get<UserOutcomeDetail>('/useroutcomes/getuseroutcome', {
        params: {
          userOutcomeId,
          userKey,
        },
      })
      .pipe(
        catchAndSurfaceError(
          this.translateService.instant(
            'UserProfileSvc_ProblemAccessingCollection'
          )
        )
      );
  }

  /**
   * Show the add modal for a userOutcome - award, degree, accomplishment, certificate
   * @param sourceTarget - the element ref for the Add button
   * @param outcomeType - the type of userOutcome to add - award, accomplishment, degree or certificate
   */
  public addUserOutcome(
    sourceTarget: ElementRef<any>,
    outcomeType: OutcomeType
  ): Observable<any> {
    return this.userOutcomeModalService.add({
      outcomeType,
      sourceTarget,
      trackingAction: 'Achievement Added',
      trackingArea: 'Profile',
    });
  }
}
